// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","text":"styles_text__N60Nd"};